var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{attrs:{"active":_vm.loading}},[_c('atom-spinner',{attrs:{"animation-duration":1000,"size":60,"color":_vm.themeColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }